export function capitalizeFirstLetter(string = '') {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function titleize(string = '') {
  if (string === null) return '';

  return string
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/(?:^|\s|-)\S/g, (x: string) => x.toUpperCase());
}

export function humanize(string = '') {
  return string
    .replace(/^[\s_]+|[\s_]+$/g, '')
    .replace(/[_\s]+/g, ' ')
    .replace(/^[a-z]/, (m) => m.toUpperCase());
}

export function humanizeBoolean(boolean?: boolean | null) {
  if (boolean === undefined || boolean === null) {
    return undefined;
  }

  return boolean ? 'Yes' : 'No';
}
